import { __extends } from 'tslib';
import { OutputStream as OutputStream$1 } from './OutputStream.js';

/**
 * @module ByteArrayOutputStream
 * @author nuintun
 * @author Kazuhiko Arase
 */
var ByteArrayOutputStream = /*#__PURE__*/ (function (_super) {
    __extends(ByteArrayOutputStream, _super);
    function ByteArrayOutputStream() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.bytes = [];
        return _this;
    }
    ByteArrayOutputStream.prototype.writeByte = function (byte) {
        this.bytes.push(byte);
    };
    ByteArrayOutputStream.prototype.toByteArray = function () {
        return this.bytes;
    };
    return ByteArrayOutputStream;
}(OutputStream$1));

export { ByteArrayOutputStream };
